import CheckboxField from 'components/form-fields/formik/CheckboxField';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { buildFormPath } from 'subdomains/cpo/screens/GroupsAndPolicies/formpath';
import { Container, Form } from 'semantic';

type Props = {
  basePath: string;
};

export const RestrictionsSelector = (props: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Container>
        <Form.Group>
          <Form.Field>
            <label>{t('tarif.restrictions.restrictBy', 'Restrict by')}</label>
          </Form.Field>
          <CheckboxField
            name={buildFormPath('duration.enabled', props.basePath)}
            label={t(
              'tarif.restrictions.enableDurationRestrictions',
              'Session duration'
            )}
          />
          <CheckboxField
            name={buildFormPath('energy.enabled', props.basePath)}
            label={t('tarif.restrictions.enableEnergyRestrictions', 'Energy')}
          />
          <CheckboxField
            name={buildFormPath('daysOfWeek.enabled', props.basePath)}
            label={t(
              'tarif.restrictions.enableDaysOfWeekRestrictions',
              'Days of the week'
            )}
          />
          <CheckboxField
            name={buildFormPath('timeOfDay.enabled', props.basePath)}
            label={t(
              'tarif.restrictions.enableTimeOfDayRestrictions',
              'Time of the day'
            )}
          />
          <CheckboxField
            name={buildFormPath('date.enabled', props.basePath)}
            label={t(
              'tarif.restrictions.enableDateRestrictions',
              'Validity period'
            )}
          />
        </Form.Group>
      </Container>
    </>
  );
};
